import { WorkOrderQRCodeResponse } from './QRCode.types';
import { publicInstance } from '@/api/axiosInstance';

export async function getWorkOrderByGuid(guid: string) {
  const result = await publicInstance.get<WorkOrderQRCodeResponse>(
    `/workorder/v1/QRCode/workorder?Id=${guid}`,
  );

  return result.data;
}
